interface ZodRuntime {
  config?: (settings: { jitless: boolean }) => unknown;
  core?: { version?: { major: number; minor: number; patch: number } };
}

/** Configure the existing module only when it supports skipping the CSP eval probe. */
export function configureZodCsp(module: unknown): boolean {
  if (!module || typeof module !== 'object') return false;
  const zod = module as ZodRuntime;
  const version = zod.core?.version;
  // Earlier Zod 4 releases still probe Function even with jitless enabled.
  if (
    typeof zod.config !== 'function' ||
    version?.major !== 4 ||
    typeof version.minor !== 'number' ||
    typeof version.patch !== 'number' ||
    version.minor < 4 ||
    (version.minor === 4 && version.patch < 3)
  ) return false;

  zod.config({ jitless: true });
  return true;
}
